import { useQuery } from '@tanstack/react-query';

import { getAllRestorants } from '../../../store/Settings/api';
import { Breadcrumbs } from '../../../components/Breadcrumbs';
import Button from '../../../components/Button/Button';
import { SearchBar } from '../StoresPage/SearchBar';
import Loading from '../../../components/Loading';
import { ArchivedStoresList } from './ArchivedStoresList';
import { useTranslation } from 'react-i18next';
import { OverLay } from '../../../components/OverLay';

const mockStores = [
    {
        id: 27,
        name: 'test',
        photo: null,
        point: null,
        address: 'test',
        comment: null,
        description: null,
        rating: null,
        price: null,
        welcome_header: null,
        welcome_text: null,
        promo_header: null,
        chain_id: 3,
        pos_type: null,
        taxation: null,
        choose_table_by_code: false,
        has_delivery: false,
        has_takeaway: false,
        has_dine_in: false,
        phone: null,
        opens_at: '12:00 AM',
        closes_at: '1:00 AM',
        time_zone_name: 'US/Samoa',
        service_charge_percent: null,
        default_integration_id: null,
        is_open: false,
        times: [
            {
                id: 48,
                restaurant_id: 27,
                status: 'enabled',
                day: 'monday',
                from: '00:00:00',
                to: '01:00:00',
            },
        ],
        integration: null,
    },
];

export const ArchivedStoresPage = () => {
    const { t } = useTranslation();

    // const { data: { data: stores = [] } = {}, isLoading } = useQuery(['stores'], getAllRestorants);
    const isLoading = false;

    const pages = [
        { name: t('Stores'), path: '/chain/stores' },
        { name: t('Archived'), path: '/chain/stores/archive' },
    ];

    return (
        <>
            <Breadcrumbs pages={pages} />

            <OverLay text="On development stage" textClassName="text-3xl">
                <div className="max-w-screen-lg flex flex-col lg:flex-row lg:justify-between items-start lg:items-center">
                    <Button
                        type="link"
                        to="/chain/stores/create"
                        className="whitespace-nowrap h-9 inline-flex items-center rounded-lg border border-transparent bg-purple-500 px-14 py-1.5 text-sm font-bold text-white shadow-sm hover:bg-purple-600 focus:outline-none"
                    >
                        {t('Add store')}
                    </Button>

                    {mockStores.length !== 0 && <SearchBar />}
                </div>
                <Loading loading={isLoading}>
                    {mockStores.length === 0 ? (
                        <div className="mt-4 p-6 max-w-4xl bg-white rounded-xl shadow-lg flex flex-col">
                            <h3 className="text-lg font-bold text-black">{t('Create and Manage your Stores')}</h3>
                            <span className="mt-2 text-sm text-gray-800">{t('Welcome to your store manager. Here you will be able to create and manage all of your stores at every location')}</span>
                        </div>
                    ) : (
                        <div className="mt-4 p-6 max-w-screen-lg bg-white rounded-lg shadow-md flex flex-col">
                            <ArchivedStoresList stores={mockStores} />
                        </div>
                    )}
                </Loading>
            </OverLay>
        </>
    );
};
